import type { TFunction } from '~/core/i18n'

type TranslationsKeys =
  | 'hoursKey'
  | 'hourKey'
  | 'minutesKey'
  | 'minuteKey'
  | 'secondsKey'
  | 'secondKey'

type TimerTranslations = Record<TranslationsKeys, string>

const timerTranslationsKeys: TimerTranslations = {
  hoursKey: 'timer_hour_other',
  hourKey: 'timer_hour_one',
  minutesKey: 'timer_minute_other',
  minuteKey: 'timer_minute_one',
  secondsKey: 'timer_second_other',
  secondKey: 'timer_second_one',
}

export const getTimerTranslations = (t: TFunction): TimerTranslations => {
  const arrayKeys = Object.keys(timerTranslationsKeys) as TranslationsKeys[]
  return arrayKeys.reduce(
    (previousValue, currentKey) => ({
      ...previousValue,
      [currentKey]: t(timerTranslationsKeys[currentKey]),
    }),
    {} as TimerTranslations
  )
}
